// Politique de sponsoring — premier écran migré vers React.
//
// Choisi en premier parce qu'il ne fait que lire : pas d'abonnement, pas d'état,
// pas d'écriture. Il sert de banc d'essai au pont entre les deux mondes.
//
// Le texte n'est toujours pas ici : il vit dans js/config.js (clé `sponsoring`),
// pour rester modifiable sans toucher au code. Référence : SPONSORING.md

import { APP } from "../../config.js";
import Icone from "../Icone.jsx";

const ICONES = {
  eglise: "membres",
  verset: "commenter",
  danger: "options",
  commenter: "commenter",
  fil: "fil",
  options: "options",
  membres: "membres",
  messages: "messages",
};

/**
 * Une règle peut contenir **du gras**, et rien d'autre.
 *
 * Dans le monde d'avant il fallait échapper le texte à la main avant d'y
 * glisser du HTML. Ici React échappe tout ce qu'on lui donne : on découpe la
 * chaîne et on rend des éléments. Plus d'échappement à ne pas oublier, et
 * l'injection devient structurellement impossible.
 */
function Regle({ texte }) {
  const morceaux = String(texte).split(/\*\*([^*]+)\*\*/g);
  return (
    <li>
      {morceaux.map((m, i) => (i % 2 === 1 ? <strong key={i}>{m}</strong> : m))}
    </li>
  );
}

export default function Sponsoring() {
  const p = APP.sponsoring;
  const depuis = new Date(p.dateEffet).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="colonne">
      <div className="entete-page">
        <h1 className="titre-page">Politique de sponsoring</h1>
      </div>

      <section className="carte politique-esprit">
        <p>{p.esprit}</p>
        <p className="petit texte-doux">
          Version {p.version} — en vigueur depuis le {depuis}.
        </p>
      </section>

      {p.sections.map((s, i) => (
        <section
          key={i}
          className={`carte politique-section${s.icone === "danger" ? " est-interdit" : ""}`}
        >
          <h2 className="politique-titre">
            <Icone nom={ICONES[s.icone] || "options"} taille={19} /> {s.titre}
          </h2>
          <ul className="politique-regles">
            {s.regles.map((r, j) => (
              <Regle key={j} texte={r} />
            ))}
          </ul>
        </section>
      ))}

      <section className="carte">
        <h2 className="politique-titre">Une question ?</h2>
        <p className="texte-doux">
          Écrivez à un responsable depuis l'application : il vous répondra avant que vous
          n'engagiez quoi que ce soit.
        </p>
        <a className="btn btn--gris btn--bloc" href="#/membres">
          Trouver un responsable
        </a>
      </section>
    </div>
  );
}
